/**
 * Order-insensitive equality for flat filter objects (primitive/Date/array values).
 * Plain `JSON.stringify(a) === JSON.stringify(b)` is key-order-sensitive, which
 * breaks when the two objects were built by different code paths (e.g. a
 * `useState` initializer vs. a zod `.transform()` that reorders keys) even
 * though their values are identical.
 */
export const isShallowEqualJSON = (
  a: Record<string, unknown>,
  b: Record<string, unknown>,
): boolean =>
  JSON.stringify(a, Object.keys(a).sort()) ===
  JSON.stringify(b, Object.keys(b).sort());
